module.exports = __webpack_public_path__ + "static/img/loginindex2.503fa38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginindex2.png
// module id = 349
// module chunks = 0